<template>
  <tr>
    <slot />
  </tr>
</template>

<style lang="postcss" scoped>
tbody tr {
  @apply border-gray-100 border-b;
}
</style>
